<template>
  <div class="row">
    <div class="col-sm-12">
      <p>
        <strong>{{ $t("seleccione-opciones") }}:</strong>
      </p>
      <!--  {{ datosNormalizados }} -->

      <div
        class="list-group-item list-group-item-action flex-column align-items-start"
      >
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1">{{ $t("realizar pago") }}</h5>
        </div>
        <p class="mb-1">
          {{ $t("importe total") }}:
          <strong>{{ importeTotal.toFixed(2) }} €</strong>
        </p>
        <div
          class="woocommerce-form-row woocommerce-form-row--wide form-row form-row-wide mb-10"
        >
          <label class="principal" for="account_last_name">
            &nbsp;{{ $t("formas pago") }}:
            <span class="required">*</span>
          </label>
          <div class="rprincipal">
            <div class="row">
              <div class="col-12">
                <div
                  class="custom-control custom-radio"
                  v-if="expoData.redsys === 1"
                >
                  <input
                    type="radio"
                    id="customRadio4"
                    name="customRadio"
                    value="redsys"
                    class="custom-control-input"
                    v-model="tipoPago"
                  />
                  <label class="custom-control-label" for="customRadio4">{{
                    $t("tarjeta-credito")
                  }}</label>
                  <br />
                  <small>({{ $t("tarjeta-credito-texto-no-funciona") }})</small>
                </div>
                <div
                  class="custom-control custom-radio"
                  v-if="expoData.transfer === 1"
                >
                  <input
                    type="radio"
                    id="customRadio5"
                    name="customRadio"
                    value="transfer"
                    class="custom-control-input"
                    v-model="tipoPago"
                  />
                  <label class="custom-control-label" for="customRadio5">{{
                    $t("transferencia-bancaria")
                  }}</label>
                </div>
                <div
                  class="custom-control custom-radio"
                  v-if="expoData.paypal === 1"
                >
                  <input
                    type="radio"
                    id="customRadio6"
                    name="customRadio"
                    value="paypal"
                    class="custom-control-input"
                    v-model="tipoPago"
                  />
                  <label class="custom-control-label" for="customRadio6">{{
                    $t("paypal-tarjeta-credito")
                  }}</label>
                  <br />
                  <small>{{ textoPaypal }}</small>
                  <br />
                  <small v-if="tipoPago === 'paypal'">
                    {{ $t("precio final") }}: {{ importe.toFixed(2) }} € +
                    {{ comisionPaypal.toFixed(2) }} € =
                    <b
                      >{{
                        (+importe.toFixed(2) + comisionPaypal).toFixed(2)
                      }}
                      €</b
                    >
                  </small>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <p class="mt-3 text-right">                      
                      <button
                        v-if="
                          componentPago !== null && mostrarPasarela === false
                        "
                        class="btn btn-danger"
                        @click.prevent="mostrarPasarelaPago"
                      >
                        {{ textoBotonPago }}
                      </button>
                    </p>
                  </div>

                  <!--     {{mostrarPasarela}} -->
                  <p class="mt-3 text-right" style="height:75px;">
                    <!-- <a name id class="btn btn-primary" href="#" role="button">Proceder al pago</a> -->
                    <component
                      :is="componentPago"
                      v-if="componentPago !== null && mostrarPasarela === true"
                      :datos="datos"
                      :importe="importe"
                    />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-5"></div>
    </div>
    <!--  {{datos.inscripciones}} -->
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "ins-tipo-pago-comp",
  props: ["datos", "importe", "tarifa", "datosNormalizados"],
  data: () => ({
    tipoPago: null,
    componentPago: null,
    mostrarPasarela: false
  }),
  methods: {
    ...mapActions("inscription", ["uploadInscriptionData"]),
    mostrarPasarelaPago() {
      const datosGenerales = {
        tipo_pago: this.tipoPago,
        condiciones_aceptadas: this.datos.aceptadasCondiciones,
        socio: this.datos.socio,
        socioNumero: this.datos.socioNumero,
        importe: this.importeTotal.toFixed(2),
        expo_id: this.datos.expoId,
        user_id: this.datos.userData.id,
        comisiones: this.comisionPaypal
      };
      const otrosConceptos = this.datos.otrosConceptos;
      const salida = {
        datosGenerales,
        datosNormalizados: this.datosNormalizados,
        otrosConceptos,
        grupoCria: this.datos.datosGrupoCria,
        parejas: this.datos.datosParejas
      };
      console.log(salida);
      this.uploadInscriptionData(salida).then(res => {
        console.log(res);
        // this.mostrarPasarela = true;
      });
      return;
    }
  },
  computed: {
    /*  texto boton pasarela pago */
    textoBotonPago() {
      if (this.tipoPago === "transfer") {
        return this.$t("realizar-inscripcion");
      } else {
        return this.$t("proceder pago");
      }
    },
    //datos de la expo
    expoData() {
      return this.datos.expoData;
    },
    //comision paypal
    comisionPaypal() {
      const tmp = this.expoData.expo_paypal;
      if (tmp.comision_cargo_canina === 1) {
        return 0;
      }
      return (
        (this.importe * parseFloat(tmp.comision_total)) / 100 +
        parseFloat(tmp.importe_operacion)
      );
    },
    // importe total
    importeTotal() {
      if (this.tipoPago === null) {
        return this.importe;
      } else {
        //si es paypal
        if (this.tipoPago === "paypal") {
          return this.importe + this.comisionPaypal;
        } else {
          return this.importe;
        }
      }
    },

    //texto de paypal
    textoPaypal() {
      const tmp = this.expoData.expo_paypal;
      if (tmp.comision_cargo_canina === 1) {
        return "";
      }
      const comision =
        (this.importe * parseFloat(tmp.comision_total)) / 100 +
        parseFloat(tmp.importe_operacion);
      const salida = this.$t("texto_cargo_adicional", [comision.toFixed(2)]);
      return salida;
    }
  },
  watch: {
    tipoPago(newValue, oldValue) {
      console.log(newValue, oldValue);
      //llamamos al nuevo componente y lo mostramos dependiendo del tipo de pago a realizar
      if (newValue !== null) {
        if (newValue === "redsys") {
          //mostramos el componente redsys
          this.componentPago = () =>
            import("./pasarelas-pago/Inscriptions-pasarela-redsys-comp");
        } else if (newValue === "transfer") {
          //mostramos el componente transferencia
          this.componentPago = () =>
            import("./pasarelas-pago/Inscriptions-pasarela-transfer-comp");
        } else if (newValue === "paypal") {
          //mostramos el componente paypal
          this.componentPago = () =>
            import("./pasarelas-pago/Inscriptions-pasarela-paypal-comp");
        }
      }
    }
  },
  mounted() {
    console.log("estos son los datos: ", this.datos);
  }
};
</script>

<style scoped></style>
